import { actionTypes } from 'app/types/action_types';

const initialState = {
  showVideoSubscriptions: false,
};

const mapPayload = (payload) => {
  if (Object.keys(payload).length === 0) return initialState;

  return {
    showVideoSubscriptions: payload.show_video_subscriptions,
  };
};

// eslint-disable-next-line default-param-last
const videoEditorReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return mapPayload(action.payload);
    default:
      return state;
  }
};

export default videoEditorReducer;
